import { Button } from "@dash/form";
import { useTheme } from "@emotion/react";
import { MdLogout } from "react-icons/md";

import { navAccent } from "./navConstants";

type Props = {
  onSignOut: () => void;
};

export const NavSignOutButton: React.FC<Props> = ({ onSignOut }) => {
  const theme = useTheme();

  return (
    <Button
      onClick={onSignOut}
      icon={<MdLogout css={{ width: "1rem", height: "1rem" }} />}
      css={{
        width: "100%",
        justifyContent: "flex-start",
        gap: "0.625rem",
        padding: "0.625rem 0.75rem",
        background: "transparent",
        color: navAccent,
        fontFamily: theme.displayFontFamily,
        fontSize: "0.875rem",
        fontWeight: 500,
        border: `1px solid ${theme.colors.skeleton}`,
        borderRadius: theme.smallBorderRadius,
        "&:hover": { background: "rgba(0,0,0,0.04)" },
      }}
    >
      Wyloguj
    </Button>
  );
};
